export default {
    price: '{{price, 0,0}}',
    priceWithKc: '$t(number:spaceFormattedNumber) $t(unit:kc)'
};
